import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTruckFast } from '@fortawesome/pro-regular-svg-icons';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { faDownToLine, faShareNodes } from '@fortawesome/pro-light-svg-icons';
import { faArrowRotateLeft, faMinus, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { faTruck, faPlus, faHeart, faTrash, faCircleInfo, faHouse } from '@fortawesome/sharp-regular-svg-icons';
import { faArrowRight, faArrowLeft } from '@fortawesome/sharp-solid-svg-icons';
import { faPrint, faFilter } from '@fortawesome/sharp-light-svg-icons';
import { faPuzzle, faChevronRight, faCircleQuarters } from '@fortawesome/pro-thin-svg-icons';
library.add(faTruckFast);
library.add(faMinus);
library.add(faTruck);
library.add(faTrash);
library.add(faPlus);
library.add(faCircleInfo);
library.add(faArrowRotateLeft);
library.add(faArrowRight);
library.add(faArrowLeft);
library.add(faPuzzle);
library.add(faChevronRight);
library.add(faCircleQuarters);
library.add(faDownToLine);
library.add(faShareNodes);
library.add(faPrint);
library.add(faHeart);
library.add(faFilter);
library.add(faTriangleExclamation);
library.add(faSpinnerThird);
library.add(faHouse);
export const falPlugin = {
    install(app) {
        app.component('font-awesome-icon', FontAwesomeIcon);
    },
};
